import { takeSnapshotAtom } from "@zapier/canvas-state";
import { useSetAtom } from "jotai";
import useUpdateNode from "./useUpdateNode";
import { useEffect, useRef } from "react";

type Props = {
  label?: string;
  newTitle?: string;
};

export default function useMaybeSaveTitleOnUnmount({ newTitle, label }: Props) {
  const takeSnapshot = useSetAtom(takeSnapshotAtom);
  const updateNodeAndSave = useUpdateNode();

  const newTitleRef = useRef(newTitle);
  const labelRef = useRef(label);

  // Due to closure, we need to store the newTitle and label in refs to access them in the cleanup function or else they'll be outdated
  useEffect(() => {
    newTitleRef.current = newTitle;
  }, [newTitle]);

  useEffect(() => {
    labelRef.current = label;
  }, [label]);

  useEffect(() => {
    return () => {
      const hasTitleChanged = newTitleRef.current !== labelRef.current;
      if (hasTitleChanged) {
        takeSnapshot();

        updateNodeAndSave(
          {
            data: {
              label: newTitleRef.current,
            },
          },
          { shouldSave: true },
        );
      }
    };
    // Intentionally leaving the dependencies array empty to ensure this runs on unmount only
  }, [takeSnapshot, updateNodeAndSave]);
}
